<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader"/>
      <rule-game :value="ruleGame"/>
      <rule-game :value="ruleScore"/>
      <rule-game :value="ruleInscreasePoint"/>
      <rule-game :value="ruleSpecial"/>
    </div>
  </div>
</template>

<script>
import Board from '../../assets/gamerule/paikeang/Board_Pk.png';
import ruleKang from '../../assets/gamerule/paikeang/PK_Asset_Info_Web_Text1.png';
import ruleKang2 from '../../assets/gamerule/paikeang/PK_Asset_Info_Web_Text2.png';
import rulescoreCard from '../../assets/gamerule/paikeang/PK_Asset_Info_Web1.png';
import ruleOne from '../../assets/gamerule/paikeang/PK_Info_Game1.png';
import ruleTwo from '../../assets/gamerule/paikeang/PK_Info_Game2.png';
import ruleThree from '../../assets/gamerule/paikeang/PK_Info_Game3.png';
import ruleFour from '../../assets/gamerule/paikeang/PK_Info_Game4.png';
import ruleCardOne from '../../assets/gamerule/paikeang/PK_Asset_Info_Web2.png';
import ruleCardTwo from '../../assets/gamerule/paikeang/PK_Asset_Info_Web3.png';
import ruleCardThree from '../../assets/gamerule/paikeang/PK_Asset_Info_Web4.png';
import ruleCardFour from '../../assets/gamerule/paikeang/PK_Asset_Info_Web5.png';
import ruleCardFive from '../../assets/gamerule/paikeang/PK_Asset_Info_Web6.png';
import ruleCardSix from '../../assets/gamerule/paikeang/PK_Asset_Info_Web7.png';

export default {
  name: 'rule_paikeng',
  data() {
    return {
      ruleHeader: {
        gameName: 'ไพ่แคง (kang)',
        boardImg: Board,
      },
      ruleGame: [
        {
          type: 'imageNoborder',
          image: ruleKang,
          class: 'w-30',
        },
        {
          type: 'text',
          text: 'สามารถเริ่มเล่นได้สูงสุด 5 คน และต่ำสุด 2 คน เปิดไพ่เมื่อมีผู้เล่นแคง ผู้เล่นที่มีแต้มน้อยที่สุดเป็นผู้ชนะ ไพ่ A 1 2 3 4 5 6 7 8 9 10 มีแต้มตามตัวเลขของไพ่ และ J Q K มีแต้มเท่ากับ 10 หน่วย',
        },
      ],
      ruleScore: [
        {
          type: 'imageTextspace',
          image: rulescoreCard,
          class: 'w-70',
          text1: '1 - 9 แต้ม',
          text2: '10 แต้ม',
        },
        {
          type: 'twoImageTextNew',
          image: ruleOne,
          image2: ruleTwo,
          class: 'kangRule',
          textHead: '1. จั่ว',
          text: 'คือ ผู้เล่นจะได้ไพ้ 5 ใบ ถ้าหากผู้เล่นมีไพ่เหมือนกันกับที่ผู้เล่นคนก่อนหน้าทิ้ง สามารถทิ้งได้โดยไม่ต้องจั่ว หากไม่มีให้จั่วขึ้นมา 1 ใบ และทิ้งไพ่ใดก็ได้บนมือ 1 ใบ หากมีไพ่เหมือนกันบนมือ สามารถลงคู่หรือตองได้ ',
        },
        {
          type: 'imageTextNew',
          image: ruleThree,
          class: 'kangRule',
          textHead: '2. ไหล',
          text1: 'คือ การทิ้งไพ่ที่เหมือนกับผู้เล่นก่อนหน้านี้ โดยคนที่ถูกไหลจะเสียเงินให้คนที่ไหล',
        },
        {
          type: 'imageTextNew',
          image: ruleFour,
          class: 'kangRule',
          textHead: '3. แคง',
          text1: 'คือ แคงเมื่อคิดว่าแต้มไพ่บนมือของผู้เล่นเหลือน้อยที่สุด',
        },
      ],
      ruleInscreasePoint: [
        {
          type: 'imageNoborder',
          image: ruleKang2,
          class: 'w-40',
        },
        {
          type: 'text',
          text: 'ค่าไหล',
          class: 'textHighlight ml-2',
        },
        {
          type: 'text',
          text: 'ไหลไพ่ 1 ใบ --------------------------------------------------------- 0.5 เท่า',
          class: 'ml-5',
        },
        {
          type: 'text',
          text: 'ค่าแคงชนะ',
          class: 'textHighlight ml-2',
        },
        {
          type: 'text',
          text: '1.แคงรอบแรก',
          class: 'ml-4',
        },
        {
          type: 'text',
          text: 'ได้จากทุกคน -------------------------------------------------------- 2 เท่า',
          class: 'ml-5',
        },
        {
          type: 'text',
          text: '2.แคงรอบอื่น',
          class: 'ml-4',
        },
        {
          type: 'text',
          text: 'ได้จากทุกคน -------------------------------------------------------- 1 เท่า',
          class: 'ml-5',
        },
        {
          type: 'text',
          text: 'ค่าแคงแพ้',
          class: 'textHighlight ml-2',
        },
        {
          type: 'text',
          text: '1.แคงรอบแรก',
          class: 'ml-4',
        },
        {
          type: 'text',
          text: 'เสียให้ผู้เล่นแต้มน้อยที่สุด ------------------------------------------- 3 เท่า',
          class: 'ml-5',
        },
        {
          type: 'text',
          text: 'ให้ผู้เล่นอื่น ---------------------------------------------------------- 2 เท่า',
          class: 'ml-5',
        },
        {
          type: 'text',
          text: '2.แคงรอบอื่น',
          class: 'ml-4',
        },
        {
          type: 'text',
          text: 'เสียให้ผู้เล่นแต้มน้อยที่สุด ------------------------------------------- 2 เท่า',
          class: 'ml-5',
        },
        {
          type: 'text',
          text: 'ให้ผู้เล่นอื่น ---------------------------------------------------------- 1 เท่า',
          class: 'ml-5',
        },
        {
          type: 'text',
          text: 'ค่าชนะดูด',
          class: 'textHighlight ml-2',
        },
        {
          type: 'text',
          text: 'ผู้เล่นที่โดนดูดเสีย -------------------------------------------------- 3 เท่า',
          class: 'ml-5',
        },
        {
          type: 'text',
          text: 'ให้ผู้เล่นอื่น ---------------------------------------------------------- 1 เท่า',
          class: 'ml-5',
        },
        {
          type: 'text',
          text: 'ค่าน็อค',
          class: 'textHighlight ml-2',
        },
        {
          type: 'text',
          text: 'ผู้เล่นทุกคนจ่าย ----------------------------------------------------- 3 เท่า',
          class: 'ml-5',
        },
        {
          type: 'text',
          text: 'ไพ่พิเศษ',
          class: 'textHighlight ml-2',
        },
        {
          type: 'text',
          text: 'โดยเรียงจาก  สเตรชฟลัช > โฟร์การ์ด > เห่า > สี > เรียง > ตอง ',
          class: 'ml-5',
        },
      ],
      ruleSpecial: [
        {
          type: 'imageTextNew',
          image: ruleCardOne,
          class: 'w-50',
          textHead: 'สเตรชฟลัช',
          text1: 'คือ ไพ่ที่มีดอกเดียวกันและเรียงกัน เช่น 10 , J , Q , K , A ชนะได้',
          textSub: '7เท่า',
          text2: 'ถ้าไพ่ชนกัน ให้ดูไพ่ที่มีค่าสูงที่สุดผู้มีแต้มมากสุดชนะ',
        },
        {
          type: 'imageTextNew',
          image: ruleCardTwo,
          class: 'w-50',
          textHead: 'โฟร์การ์ด',
          text1: 'คือ ไพ่ที่มีแต้มเท่ากัน 4 ใบ ไม่จำเป็นต้องเป็นดอกเดียวกัน ชนะได้',
          textSub: '6 เท่า',
          text2: 'จากผู้เล่นทุกคน',
        },
        {
          type: 'imageTextNew',
          image: ruleCardThree,
          class: 'w-50',
          textHead: 'เห่า',
          text1: 'คือ ไพ่ที่เหมือนกัน 3 ใบ และอีก 2 ใบเหมือนกัน ชนะได้',
          textSub: '5 เท่า',
          text2: 'จากผู้เล่นทุกคน',
        },
        {
          type: 'imageTextNew',
          image: ruleCardFour,
          class: 'w-50',
          textHead: 'สี',
          text1: 'คือ ไพ่ที่มีดอกเดียวกัน 5 ใบ ชนะได้',
          textSub: '4 เท่า',
          text2: 'จากผู้เล่นทุกคน ถ้าเท่ากันให้ดูที่ดอก ดอกใหญ่ที่สุดชนะ',
        },
        {
          type: 'imageTextNew',
          image: ruleCardFive,
          class: 'w-50',
          textHead: 'เรียง',
          text1: 'คือ ไพ่ที่เรียงลำดับกัน 5 ใบ ( เรียงต่ำที่สุดคือ A 1 2 3 4 และเรียงสูงที่สุดคือ 10 J Q K A) ชนะได้',
          textSub: '3 เท่า',
          text2: 'จากผู้เล่นทุกคน',
        },
        {
          type: 'imageTextNew',
          image: ruleCardSix,
          class: 'w-50',
          textHead: 'ตอง',
          text1: 'คือ ไพ่ที่มีแต้มเดียวกัน 3 ใบ ชนะได้',
          textSub: '2 เท่า',
          text2: 'จากผู้เล่นทุกคน',
        },
      ],

    };
  },
};
</script>

<style lang="css" scoped>
.white-color {
  color: white;
}

.font-big {
  font-size: 1.8vw;
}
</style>
